import React, { useEffect, useState } from 'react';

import { Store } from "redux";
import { Provider } from "react-redux";
import {
    RouterProvider
} from "react-router-dom";
import { ApplicationState } from './types/commonTypes';
import './App.scss';
import HeaderCmp from "./components/header/Header";
import { RouteWrapper } from "./components/styled/Containers.style";
import { router } from "./Router";
import { useAppSelector } from './store/hooks';
import { getIsInAppClass } from './utils/utils';
import { selectCommunicationData } from './store';
import useIsLinearPreRun from './utils/hooks/useIsLinearPreRun';
import HeaderLinearCmp from './components/header/HeaderLinear';
import { LINEAR_PATHS } from './routes/linearRouteConstants';
import { AUTH_CONFIRM_PATHS } from './routes/AuthConfirmRouter';

declare global {
    interface Window {
        INITIAL_REDUX_STATE: any;
        REACT_APP_CAPTCHA_SITEKEY: string;
        REACT_APP_SKIP_CAPTCHA: string;
        REACT_APP_NODE_ENV: string;
        REACT_APP_POLLING_INTERVAL_IN_MS: number;
        REACT_APP_VTV_API_ENDPOINT: string;
        REACT_APP_HERE_API_KEY: string;
        REACT_APP_CAI_COMMUNICATION_EXPIRATION_IN: string;
        REACT_APP_CAI_SIGNATURE_EXPIRATION_IN: string;
        utag: any;
    }
}

interface MainProps {
    store: Store<ApplicationState>;
}
const AppCmpWithStore = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const { companyName } = communication
    const isLinear = useIsLinearPreRun();
    const [isInvLinear, setIsInvLinear] = useState<boolean>(false);

    /* istanbul ignore next */
    useEffect(() => {
        if (!communication?.token) {
            return
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [communication?.token])

    useEffect(() => {
        if (isLinear) {
            document.title = "Linear Realtime";

            const link: HTMLLinkElement | null = document.querySelector("#favicon");
            if (link) {
                link.href = '/faviconLinear.ico';

                // Forza il reload della favicon (trucchetto)
                const newLink = link.cloneNode(true) as HTMLLinkElement;
                link.parentNode?.replaceChild(newLink, link);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLinear]);

    useEffect(() => {
        if (isLinear) {
            try {
                const VALID_LINEAR_PATHS = [
                    LINEAR_PATHS.TOKEN_EXPIRED,
                    LINEAR_PATHS.END_PROCESS_PAGE,
                    LINEAR_PATHS.END_THANK_YOU_PAGE,
                    LINEAR_PATHS.END_TO_DRIVER_THANK_YOU_PAGE,
                    AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_CANCEL,
                    AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_PROCESS_SUCCESS,
                    AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_TOKEN_EXPIRED
                ];
                const url = new URL(window.location.href);
                const segments = url.pathname.split("/").filter(Boolean);
                const lastSegment = segments[segments.length - 1] ?? "";

                setIsInvLinear(VALID_LINEAR_PATHS.includes(lastSegment));
            } catch (err) {
                console.error("Invalid URL:", err);
                setIsInvLinear(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.href, isLinear]);

    const isInAppClass = getIsInAppClass();

    return (
        <>
            <div className={`app ${isInAppClass}`}>
                {isLinear === true && <HeaderLinearCmp isInvLinear={isInvLinear} />}
                {isLinear === false && <HeaderCmp className={isInAppClass} />}
                <RouteWrapper className={`${isInAppClass} ${companyName}`}>
                    <RouterProvider router={router} />
                </RouteWrapper>
            </div>
        </>
    );
};

const App: React.FC<MainProps> = ({ store }) => {

    return (
        <>
            <Provider store={store}>
                <AppCmpWithStore />
            </Provider>
        </>
    );
};

export default App;
